import { BaseExportModal, ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { CONVENIENCE_DOORS_COLUMNS } from 'components/DataExpansionComponents/GooglePlaces/ConvenienceDoors/ConvenienceDoorsColumnsInfo'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startConvenienceDoorsExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function ConvenienceDoorExportModal(props: ExportModalProps) {
  const dataTypeName = 'Convenience Store Doors'

  const convenienceColumnHelper = createExportColumnHelper({
    columns: CONVENIENCE_DOORS_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        convenienceColumnHelper.retrieveColumn('name'),
        convenienceColumnHelper.retrieveColumn('chain_id'),
        convenienceColumnHelper.retrieveColumn('address'),
        convenienceColumnHelper.retrieveColumn('city'),
        convenienceColumnHelper.retrieveColumn('state'),
        convenienceColumnHelper.retrieveColumn('country'),
        convenienceColumnHelper.retrieveColumn('phone'),
        convenienceColumnHelper.retrieveColumn('website'),
        convenienceColumnHelper.retrieveColumn('reviews_avg'),
        convenienceColumnHelper.retrieveColumn('reviews_cnt'),
        convenienceColumnHelper.retrieveColumn('open_hours'),
        convenienceColumnHelper.retrieveColumn('chain_doors_cnt'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: `Exporting ${dataTypeName}...` }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startConvenienceDoorsExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Convenience Companies',
    })
  }

  return (
    <BaseExportModal
      title={`Select Columns for ${dataTypeName} Download`}
      subTitle={`Download up to 10,000 ${dataTypeName.toLocaleLowerCase()} at a time, with any of the following columns. Any filters already applied will remain active.`}
      submitText={`Export ${dataTypeName}`}
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
